import * as React from 'react';
export var DIVIDER_SIZE = '2px';
export var GROUP_DIVIDER_SIZE = '0px';
export function removeUndefined(obj) {
    for (var key in obj) {
        if (obj[key] === undefined) {
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete obj[key];
        }
    }
    return obj;
}
/**
 * Check whether cell group props are valid or not
 */
export function validateCellGroupProps(start, end) {
    if (start < 1 || end < 1 || start > end) {
        return false;
    }
    return true;
}
/**
 * Get an array of unique sorted hidden cells.
 */
export function getHiddenCells(hide) {
    return Array.from(new Set(hide)).sort(function (x, y) { return x - y; });
}
/**
 * Get an array of visible cells.
 */
export function getVisibleCells(columns, hide) {
    return Array(columns)
        .fill(1)
        .map(function (x, i) { return x + i; })
        .filter(function (x) { return !getHiddenCells(hide).includes(x); });
}
/**
 * Get decorative styles of data grid view.
 */
export function getGridStyles(_a) {
    var columns = _a.columns, _b = _a.group, group = _b === void 0 ? [] : _b, _c = _a.grow, grow = _c === void 0 ? [] : _c, _d = _a.hide, hide = _d === void 0 ? [] : _d, _e = _a.gridTemplateColumns, gridTemplateColumns = _e === void 0 ? [] : _e;
    // Decorate groups. For each group,
    // Make an array of cell numbers from start to end.
    // Then, find the difference (visible cells of group) and pick the first.
    // Lastly, draw a divider for the first cell and remove from others.
    var grouped = group.map(function (_a) {
        var start = _a.start, end = _a.end;
        // TODO
        // eslint-disable-next-line array-callback-return
        if (!validateCellGroupProps(start, end))
            return;
        var cells = Array(end - start + 1)
            .fill(start)
            .map(function (x, i) { return x + i; });
        var first = cells.filter(function (x) { return !getHiddenCells(hide).includes(x); })[0];
        return cells
            .map(function (cell) { return "\n      .DataGrid-Row > .DataGrid-Cell:nth-child(" + columns + "n + " + cell + ") {\n        border-left-width: " + (cell === first ? DIVIDER_SIZE : GROUP_DIVIDER_SIZE) + ";\n      }\n    "; })
            .join(' ');
    });
    // Then, let's bury the hidden cells and make sure initial visible cell(s) have no divider.
    var buried = getHiddenCells(hide).map(function (column, index) { return "\n    .DataGrid-Row > .DataGrid-Cell:nth-child(" + columns + "n + " + column + ") {\n      display: none;\n      " + (column === index + 1 ? '+ .DataGrid-Cell { border-left-width: 0; }' : '') + "\n    }\n  "; });
    // Finally, Let's shape cells.
    // Set `auto` template for all cells by default and then override `min-content` as needed.
    var shaped = "\n    grid-template-columns: " + getVisibleCells(columns, hide)
        .map(function (cell) {
        if (gridTemplateColumns.length > 0 &&
            gridTemplateColumns[cell - 1] !== undefined) {
            return gridTemplateColumns[cell - 1].trim();
        }
        else if (grow.length > 0) {
            return !grow.includes(cell) ? 'minmax(auto, min-content)' : 'auto';
        }
        return 'auto';
    })
        .join(' ') + ";\n  ";
    return grouped.concat(buried).concat([shaped]);
}
export function getColumns(props) {
    /** If a columns prop is given, use it instead of attempting to calculate columns */
    if (props.columns !== undefined && props.columns >= 0) {
        return props.columns;
    }
    /*
      NOTE: What's going on here is a little complicated due to the type
      definitions provided by React...
      If the "props.children" value is an array, then "props.children" becomes a
      "ReactNodeArray", this allows us to check that it has at least one
      child. Knowing that it has one child, we can pull that one out and cast it
      as a "ReactElement". We can confirm this by checking that
      "ReactNodeArray" is defined as "Array<ReactNode>", MEANING the first
      instance of "props.children" is definitely a single "ReactElement"
    */
    var firstNode = Array.isArray(props.children)
        ? props.children.length >= 1
            ? props.children[0]
            : null
        : null;
    return firstNode !== null ? React.Children.count(firstNode.props.children) : 0;
}
//# sourceMappingURL=utils.js.map